import React from 'react';
import PropTypes from 'prop-types';
import Button from './Button';
import IconCategoryValue from './IconCategoryValue';
import { formatClassName } from '../Util';
import noop from '../util/noop';
import { kebabCase } from 'lodash';

const Chip = ({ category, canClose, data = {}, disabled, onClick, onRemove = noop, sortable, value, ...extraProps }) => {
  const className = formatClassName([
    'chip',
    { 'disabled': disabled }
  ]);

  const dataProps = {};
  if (data.action) {
    dataProps['data-action'] = data.action;
  }
  if (data.objectId) {
    dataProps['data-object-id'] = data.objectId;
  }
  if (data.objectType) {
    dataProps['data-object-type'] = data.objectType;
  }
  if (data.componentType) {
    dataProps['data-component-type'] = data.componentType;
  } else {
    dataProps['data-component-type'] = value ? `${kebabCase(value)}-chip` : 'chip';
  }

  const performOnMouseDown = event => {
    event.stopPropagation();
  }

  const performOnClick = event => {
    if (!disabled && onClick) {
      onClick(event);
    }
  };

  const performOnRemove = event => {
    event.stopPropagation();
    if (!disabled) {
      onRemove(event);
    }
  };

  return (
    <div
      className={className}
      tabIndex={onClick && 0}
      onMouseDown={performOnMouseDown}
      onClick={performOnClick}
      {...extraProps}
      {...dataProps} >
      <IconCategoryValue
        icon={sortable ? 'reorder' : undefined}
        category={category}
        value={value}
      />
      {canClose && <Button
        icon="close"
        style="link"
        disabled={disabled}
        onClick={performOnRemove} />}
    </div>
  );
}

Chip.defaultProps = {
  canClose: true
}

Chip.propTypes = {
  canClose: PropTypes.bool,
  category: PropTypes.string,
  data: PropTypes.object,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  onRemove: PropTypes.func,
  sortable: PropTypes.bool,
  value: PropTypes.string
}

export default Chip;
